module.exports = __webpack_public_path__ + "assets/icons-40-subscription-40-px.d3ded2a4.svg";